/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './email-recipients.model';
export * from './email-recipients-rest.service';
